export default class BookingSlotCalulation {
  calculateTotalUtilizationForSlots(slots) {
    let totalPossibleBookings = 0;
    let totalBookings = 0;

    slots.forEach((slot) => {
      totalPossibleBookings += slot.total_possible_bookings;
      totalBookings += slot.bookings;
    });

    return this.calculateUtilizationRate(totalPossibleBookings, totalBookings);
  }

  calculateUtilizationRate(possibleBookings, bookings) {
    // so if we have 472 slots (possible bookings in 7 days and we have had 54 calls (bookings) we would say
    // 54/472x100=11.4%
    let result = ((bookings / possibleBookings) * 100);
    return Number.isFinite(result) ? result.toFixed(2) : '0.00';
  }
}
